(ns humbleai.belt.malli.type.email
  (:refer-clojure :exclude [type])
  (:require
   [clojure.string :as str]
   [clojure.test.check.generators :as gen]
   [malli.generator :as mg]
   [malli.core :as malli]))

(def email-regex #"(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|\"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*\")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])")

(defn email?
  [s]
  (re-matches email-regex s))

(def type
  {:email (malli/-simple-schema
           {:type :email
            :pred email?})})

(def alphanumeric-str-gen-min3-max5
  (->> (gen/vector gen/char-alphanumeric 3 5)
       (gen/fmap str/join)))

(def email-gen
  (gen/fmap
   (fn [[account domain tld]]
     (str account "@" domain "." tld))
   (gen/vector alphanumeric-str-gen-min3-max5 3)))

(defmethod mg/-schema-generator :email [_ _] email-gen)

(defn ->email
  [s]
  (first (re-find email-regex s)))

(def transformer
  {:name :email-transfomer
   :decoders {:email ->email}})
